import { useLocation } from 'react-router-dom';

import { useOpenPortal } from '@/features/billing/use-open-portal';
import { useUrlOverlay } from '@/hooks/use-url-overlay';
import { urlOverlays } from '@/constants/url-overlays';

import type { EnergyAction } from './energy-view';

export const energyActionLabels: Record<EnergyAction, string> = {
  exploreTrial: 'Explore Trial',
  comparePlans: 'Compare plans',
  startPlan: 'Start my plan now',
  payHeldCharge: 'Complete payment',
  updatePayment: 'Update payment method',
  recharge: 'Recharge',
};

/** Runs an Energy action: the plan picker, the Recharge overlay, the Start plan overlay (also for a held charge), or the Stripe portal. `opening` is true while the portal is being created. */
export const useEnergyAction = () => {
  const { pathname, search } = useLocation();
  const { open: openPlanPicker } = useUrlOverlay(urlOverlays.planPicker, urlOverlays);
  const { open: openRecharge } = useUrlOverlay(urlOverlays.recharge, urlOverlays);
  const { open: openStartPlan } = useUrlOverlay(urlOverlays.startPlan, urlOverlays);
  const { openPortal, opening } = useOpenPortal(pathname + search);

  const runEnergyAction = (action: EnergyAction) => {
    switch (action) {
      case 'exploreTrial':
      case 'comparePlans':
        openPlanPicker();
        break;
      case 'startPlan':
      case 'payHeldCharge':
        openStartPlan();
        break;
      case 'updatePayment':
        void openPortal();
        break;
      case 'recharge':
        openRecharge();
        break;
    }
  };

  return { runEnergyAction, opening };
};
